import { registerArchetype } from './index.js';
import { livingEnemies, enemySide, getRuntimes } from '../combat.js';
registerArchetype({
    id: 'dot',
    apply: ({ state, source, params }) => {
        const dmgPerTick = params.dmgPerTick ?? 5;
        const duration = params.duration ?? 3;
        const target = params.target ?? 'all_enemies';
        const enemySideKey = enemySide(source.side);
        const enemies = livingEnemies(state, source.side);
        const targets = target === 'all_enemies' ? enemies.map(e => ({ slot: e.slot })) : enemies.length > 0 ? [{ slot: enemies[0].slot }] : [];
        for (const t of targets) {
            getRuntimes(state, enemySideKey)[t.slot].statuses.push({
                id: `dot_${state.tick}_${t.slot}`,
                kind: 'dot',
                remainingTicks: duration,
                params: { dmgPerTick }
            });
            state.events.push({ t: state.tick, kind: 'status_apply', side: enemySideKey, slot: t.slot, status: 'dot', duration });
        }
    }
});
